import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as CustomerModels from '../../models/customer/customer';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from "../../models/commonModels";
import { CustomerDictionarySearchModel } from '../../models/customer/customerSearch';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {


  constructor(private httpClient: HttpClient,
    private environment: EnvironmentService) { }

  public getSearchDictionary(search: CustomerDictionarySearchModel) {
    return this.httpClient.post<CustomerModels.CustomerDictionaryListModel>(`${this.environment.getApiURL()}/customer/search-dictionary`, search);
  }

  public getDisactive() {
    return this.httpClient.get<CustomerModels.CustomerDictionaryListModel>(`${this.environment.getApiURL()}/customer/disactive-list`);
  }

  public getUsers(CustomerId: number) {
    return this.httpClient.get<CustomerModels.CustomersUserListModel>(`${this.environment.getApiURL()}/customer/${CustomerId}/users`);
  }

  public getSubcompanies() {
    return this.httpClient.get<CustomerModels.CustomerDictionaryListModel>(`${this.environment.getApiURL()}/customer/subcompanies`);
  }

  public getContractStatus() {
    return this.httpClient.get<boolean>(`${this.environment.getApiURL()}/customer/contract/status`);
  }

  public getParentChildList(Search: CustomerModels.CustomerSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<CustomerModels.CustomerListModel>(`${this.environment.getApiURL()}/customer/list/parent-child`, Search, options);
  }

  public getList(Search: CustomerModels.CustomerSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<CustomerModels.CustomerListModel>(`${this.environment.getApiURL()}/customer/list`, Search, options);
  }

  public set(Customer: Models.Request<CustomerModels.CustomerModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerModel>>(`${this.environment.getApiURL()}/customer/set`, Customer, options);
  }

  public remove(Customer: Models.Request<CustomerModels.CustomerModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseBase>(`${this.environment.getApiURL()}/customer/remove`, Customer, options);
  }

  public setActive(Customer: Models.Request<CustomerModels.CustomerModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerModel>>(`${this.environment.getApiURL()}/customer/set/active`, Customer, options);
  }

  public create(Customer: Models.Request<CustomerModels.CustomerModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerModel>>(`${this.environment.getApiURL()}/customer/create`, Customer, options);
  }

  public getCustomer(Customer: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerModel>>(`${this.environment.getApiURL()}/customer/get`, Customer, options);
  }

  public getGarages(Customer: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.Response<CustomerModels.CustomerGarageModel[]>>(`${this.environment.getApiURL()}/customer/${Customer.Id}/garages`);
  }

  public linkGarage(Link: Models.Request<CustomerModels.CustomerGarageModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerGarageModel>>(`${this.environment.getApiURL()}/customer/set/garage`, Link, options);
  }

  public linkAllGarage(Link: Models.Request<CustomerModels.CustomerGarageModel[]>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerGarageModel[]>>(`${this.environment.getApiURL()}/customer/set/garage/all`, Link, options);
  }

  public getCustomerChildListExcelReport(Search: CustomerModels.CustomerSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };

    return this.httpClient.post<Blob>(`${this.environment.getApiURL()}/customer/parent-child/report-excel`, Search, options);
  }


  public getService(Search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerServiceModel[]>>(`${this.environment.getApiURL()}/customer/services`, Search, options);
  }

  public linkService(Link: Models.Request<CustomerModels.CustomerServiceModel[]>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.CustomerServiceModel[]>>(`${this.environment.getApiURL()}/customer/services/set`, Link, options);
  }


  public getAPICustomerServiceRights(Customer: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.APICustomerServiceRightsModel[]>>(`${this.environment.getApiURL()}/customer/customerapiservice/get`, Customer, options);
  }

  public setAPICustomerServiceRights(APICustomerServiceRights: Models.Request<CustomerModels.APICustomerServiceRightsModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CustomerModels.APICustomerServiceRightsModel>>(`${this.environment.getApiURL()}/customer/customerapiservice/set`, APICustomerServiceRights, options);
  }
}
